import { useEffect, useState, useSyncExternalStore } from 'react';

/*
 * Раскладка «Разговора» на телефоне (T117; contracts/ui.md §6; FR-039): сенсорный экран (Enter переносит строку),
 * телефон до 640 px (выпадающие списки — нижние листы) и экранная клавиатура (`visualViewport`): поле сообщения
 * поднимается над ней.
 */

function media(query: string) {
  const read = () => (typeof window.matchMedia === 'function' ? window.matchMedia(query).matches : false);
  const subscribe = (on: () => void) => {
    const mq = typeof window.matchMedia === 'function' ? window.matchMedia(query) : null;
    mq?.addEventListener?.('change', on);
    window.addEventListener('resize', on);
    return () => {
      mq?.removeEventListener?.('change', on);
      window.removeEventListener('resize', on);
    };
  };
  return { read, subscribe };
}
const COARSE = media('(pointer: coarse)');
const PHONE = media('(max-width: 640px)');

/** Сенсорный экран: Enter переносит строку, отправка — кнопкой. */
export function useCoarsePointer(): boolean {
  return useSyncExternalStore(COARSE.subscribe, COARSE.read, () => false);
}

/** Телефон (до 640 px, ступень `bp-phone`): выпадающие списки — нижние листы. */
export function usePhone(): boolean {
  return useSyncExternalStore(PHONE.subscribe, PHONE.read, () => false);
}

/** Высота экранной клавиатуры над низом окна (`visualViewport`), px. */
export function useKeyboardInset(): number {
  const [inset, setInset] = useState(0);
  useEffect(() => {
    const vv = window.visualViewport;
    if (!vv) return;
    const update = () => setInset(Math.max(0, Math.round(window.innerHeight - vv.height - vv.offsetTop)));
    update();
    vv.addEventListener('resize', update);
    vv.addEventListener('scroll', update);
    return () => {
      vv.removeEventListener('resize', update);
      vv.removeEventListener('scroll', update);
    };
  }, []);
  return inset;
}
